export default "__VITE_ASSET__BMkW3JPn__"